export const DEMO_COUNTRIES = [
  { iso3: 'BRA', iso2: 'BR', name: 'Brasile', score: 6.3, scoreDisplay: 6, max_level: 2, news: 1 },
  { iso3: 'IND', iso2: 'IN', name: 'India', score: 5.8, scoreDisplay: 6, max_level: 2, news: 2 },
  { iso3: 'USA', iso2: 'US', name: 'Stati Uniti', score: 7.1, scoreDisplay: 7, max_level: 2, news: 0 },
  { iso3: 'EGY', iso2: 'EG', name: 'Egitto', score: 5.2, scoreDisplay: 5, max_level: 3, news: 1 },
  { iso3: 'CHN', iso2: 'CN', name: 'Cina', score: 6.6, scoreDisplay: 7, max_level: 2, news: 0 },
  { iso3: 'ARE', iso2: 'AE', name: 'Emirati Arabi Uniti', score: 7.9, scoreDisplay: 8, max_level: 1, news: 0 },
  { iso3: 'MEX', iso2: 'MX', name: 'Messico', score: 5.4, scoreDisplay: 5, max_level: 3, news: 1 },
  { iso3: 'NGA', iso2: 'NG', name: 'Nigeria', score: 3.6, scoreDisplay: 4, max_level: 4, news: 2 },
];

export const DEMO_NEWS = [
  { id: 'd1', iso3: 'IND', title: 'INDIA: manifestazioni.', text: '<p>Previste manifestazioni nella capitale, con limitazioni alla circolazione. Si raccomanda di evitare gli assembramenti.</p>' },
  { id: 'd2', iso3: 'EGY', title: 'EGITTO: aggiornamento sicurezza.', text: '<p>Si raccomanda la massima prudenza nelle aree di confine e di seguire le indicazioni delle Autorità locali.</p>' },
  { id: 'd3', iso3: 'NGA', title: 'NIGERIA: rischio rapimenti.', text: '<p>Si sconsigliano i viaggi non necessari in diverse regioni del Paese.</p>' },
];
